module.exports = __webpack_public_path__ + "static/media/AppleIPad.de0ab7f6.png";